import { render, staticRenderFns } from "./DinnerNews.vue?vue&type=template&id=4597e53f&"
import script from "./DinnerNews.vue?vue&type=script&lang=js&"
export * from "./DinnerNews.vue?vue&type=script&lang=js&"
import style0 from "./DinnerNews.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports